<script>
  import {slide, fade} from 'svelte/transition'
  let showMobileMenu = false;
  let menuItems = [
    { link: "#watch", text: "Watch" },
    { link: "#about", text: "About" },
    { link: "#appearing", text: "Appearing" },
    { link: "#thanks", text: "Thanks to" },
    { link: "#contact", text: "Contact" },
  ];
  function toggleMenu() {
    showMobileMenu = !showMobileMenu;
  }
</script>

<style>
  .navigation {
    position: absolute;
    z-index: 1;
    width: 100%;
    padding: 20px;
  }
  ul.navigation-menu {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    list-style: none;
    padding: 0px;
  }
  button.nav-menu-toggle {
    color: white;
    background: none;
    border: none;
    font-size: 2rem;
    padding: 0px;
  }
  .navbar {
    background: transparent;
    color: white;
  }
  .navbar-brand {
    flex: 1;
  }
  a.navbar-brand {
    color: white;
  }
  a.nav-link {
    color: white;
    font-family: "Tw Cen MT Condensed Bold", sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 1.2rem;
  }
  .mobile-navigation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-transform: uppercase;
    background: white;
    box-shadow: 1px 0px 5px #DDDDDD;
    padding-bottom: 20px;
    z-index: 1000;
  }
  .mobile-nav-item a {
    color: #242424;
    font-size: 1.4rem;
    display: block;
  }
  .mobile-navigation-brand {
    color: #CCCCCC;
  }
  .close {
    font-size: 2rem;
    display: block;
    position: absolute;
    top: 35px;
    right: 50px;
  }
</style>

{#if showMobileMenu}
  <div class="mobile-navigation" in:slide out:fade>
    <div class="mobile-navigation-brand text-center p-3 mt-4">MORE OF EVERYTHING</div>
    <span class="close" on:click="{toggleMenu}"><i class='bx bx-x'></i></span>
    {#each menuItems as item}
      <div class="mobile-nav-item text-center" in:fade><a href={item.link} class="p-3" on:click="{toggleMenu}">{item.text}</a></div>
    {/each}
  </div>
{:else}
  <nav class="navigation" id="home">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <a class="navbar-brand d-none d-md-block d-lg-block" href="#home">MORE OF EVERYTHING</a>
        </div>
        <div class="col">
          <ul class="navigation-menu">
            {#each menuItems as item}
              <li class="nav-item d-none d-md-block d-lg-block">
                <a
                  class="nav-link active"
                  aria-current="page"
                  href={item.link}>{item.text}</a>
              </li>
            {/each}
            <li class="nav-item d-block d-md-none">
              <button class="nav-menu-toggle" on:click={toggleMenu}><i class="bx bx-menu" /></button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
{/if}
